import React, { useState } from "react";
import {
  Collapse,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Nav,
  NavItem,
  UncontrolledDropdown, 
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useExternalUrls } from "../contexts/ExternalUrlsContext";
import enFlagIcon from "../assets/en.svg";
import "./NavMenu.css";

export const NavMenu = () => {
  const [collapsed, setCollapsed] = useState(true);
  const { t } = useTranslation();
  const { corridor10 } = useExternalUrls();

  return (
    <header className="site-header">
      <Navbar expand="md" className="site-navbar" container>
        <div className="site-brand-wrap">
          <NavbarBrand className="site-brand" tag={Link} to="/">
            <img src={require("../assets/corridor10_logo.png")} alt="Corridor 10" />
          </NavbarBrand>
          <NavbarToggler onClick={() => setCollapsed(!collapsed)} className="site-toggler" />
        </div>
        <Collapse isOpen={!collapsed} navbar className="site-collapse">
          <Nav navbar className="header-actions">
            <UncontrolledDropdown nav inNavbar className="register-nav-item">
              <DropdownToggle
                nav
                caret
                className="header-pill header-pill-dark register-trigger"
              >
                {t("menu:register-tab")}
              </DropdownToggle>
              <DropdownMenu end className="register-menu">
                <DropdownItem tag={Link} to="/requests/create/1" className="register-menu-item">
                  {t("menu:register-as-purchaser")}
                </DropdownItem>
                <DropdownItem tag={Link} to="/requests/create/2" className="register-menu-item">
                  {t("menu:register-as-carrier")}
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
            <NavItem className="header-login-item">
              <a href={corridor10} className="header-pill header-pill-dark" target="_blank" rel="noopener noreferrer">
                {t("landing:auth.login")}
              </a>
            </NavItem>
            <NavItem>
              <div className="language-nav-item" aria-label="Language">
                <span className="lang-en-icon" aria-hidden="true">
                  <img src={enFlagIcon} alt="English" />
                </span>
              </div>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
    </header>
  );
};
